// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3aB5f","title":"Header_title__A-C75","side":"Header_side__2mNvk"};